import { reactivePick } from '@vueuse/shared';
import type { PropType, ExtractPropTypes } from 'vue';

import { type LoadingVariantType, loadingVariantList } from '../../typings/loadingVariantType';

export const withLoadingProps = {
  /**
   * Wyświetlaj loading w elemencie
   */
  loading: {
    type: Boolean,
    default: false
  },

  /**
   * Wariant wyświetlania loadera
   */
  loadingVariant: {
    type: String as PropType<LoadingVariantType>,
    default: 'cover'
  },

  /**
   * Tekst wyświetlany w loadingu
   */
  loadingText: {
    type: String
  }
};

/**
 * Wartości do przekazania do w-loading
 *
 * @export
 * @param {*} [props={}]
 * @returns
 */
export function useLoadingProps(props: ExtractPropTypes<typeof withLoadingProps>): {
  loading: boolean;
  loadingVariant: LoadingVariantType;
  loadingText?: string;
} {
  return reactivePick(props, 'loading', 'loadingVariant', 'loadingText');
}

/**
 * Konfiguracja dla storybooka
 */
export const storiesLoadingArgs = {
  args: {
    loading: false,
    loadingVariant: 'cover',
    loadingText: ''
  },

  argTypes: {
    loading: {
      control: { type: 'boolean' }
    },
    loadingVariant: {
      options: loadingVariantList,
      control: { type: 'select' }
    },
    loadingText: {
      control: { type: 'text' }
    }
  }
};
